import React, { useEffect, useState, useCallback } from 'react';
import adminApi from './adminApi';
import { Karte, Chip, ZahlChip, Leer, Fehler } from './bausteine';

const TabZahlungen = () => {
  const [daten, setDaten] = useState(null);
  const [fehler, setFehler] = useState(null);
  const [laufend, setLaufend] = useState(null);

  const laden = useCallback(() => {
    adminApi.payments().then(setDaten)
      .catch((e) => setFehler(e.response?.data?.error || e.message));
  }, []);
  useEffect(laden, [laden]);

  const abgleichen = async (id) => {
    setLaufend(id);
    try { await adminApi.syncPayment(id); laden(); }
    catch (e) { setFehler(e.response?.data?.error || e.message); }
    finally { setLaufend(null); }
  };

  if (fehler && !daten) return <Fehler>{fehler}</Fehler>;
  if (!daten) return <Leer>Lade …</Leer>;

  return (
    <Karte
      titel={`Zahlungen (${daten.anzahl})`}
      rechts={daten.abweichungen > 0
        ? <Chip farbe="rot">{daten.abweichungen} Abweichungen</Chip>
        : <Chip farbe="gruen">deckungsgleich</Chip>}
    >
      <Fehler>{fehler}</Fehler>
      <p className="text-sm text-gray-600 mb-4">
        Stripe ist hier die Wahrheit. Der Wert in der Datenbank wurde lange
        gesetzt, <em>bevor</em> bezahlt wurde — Abweichungen sind deshalb zu erwarten.
      </p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-gray-500 border-b">
              <th className="py-2 pr-4 font-medium">Konto</th>
              <th className="py-2 pr-4 font-medium">Datenbank</th>
              <th className="py-2 pr-4 font-medium">Stripe</th>
              <th className="py-2 pr-4 font-medium">Abo</th>
              <th className="py-2 font-medium"></th>
            </tr>
          </thead>
          <tbody>
            {daten.zahlungen.map((z) => (
              <tr key={z.userId} className={`border-b border-gray-50 ${z.abweichung ? 'bg-red-50' : ''}`}>
                <td className="py-3 pr-4">
                  <span className="font-medium">{z.name}</span>
                  <span className="block text-xs text-gray-500">{z.email}</span>
                </td>
                <td className="py-3 pr-4"><ZahlChip status={z.statusDb} /></td>
                <td className="py-3 pr-4">
                  {z.statusStripe
                    ? <><ZahlChip status={z.statusStripe} />
                        <span className="block text-xs text-gray-400">{z.stripeRoh}</span></>
                    : <span className="text-gray-400 text-xs">{z.hinweis || '–'}</span>}
                </td>
                <td className="py-3 pr-4 text-xs text-gray-500 max-w-[12rem] truncate"
                    title={z.subscriptionId || ''}>
                  {z.subscriptionId || '–'}
                </td>
                <td className="py-3">
                  {z.abweichung && z.statusStripe && (
                    <button
                      onClick={() => abgleichen(z.userId)}
                      disabled={laufend === z.userId}
                      className="px-3 py-1 border border-gray-300 rounded text-xs disabled:opacity-50"
                    >
                      {laufend === z.userId ? '…' : 'übernehmen'}
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Karte>
  );
};

export default TabZahlungen;
